import { BaseProduct } from '../types';

type GetVariantOptionKeyForMaterialTypeDay = (
  product: BaseProduct,
) => BreakpointKey | null;

type BreakpointKey = 'option1' | 'option2' | 'option3';
export const getVariantOptionKeyForBreakpoint: GetVariantOptionKeyForMaterialTypeDay = product => {
  const materialIndex = product.options.findIndex(
    option => option === 'Breakpoint',
  );
  if (materialIndex === -1) return null;

  return `option${materialIndex + 1}` as BreakpointKey;
};
